module.exports = __webpack_public_path__ + "static/media/icon_book.ca549a3c.svg";